import '../../../styles/ModalFacturaEmitida.css'
import { useDispatch, useSelector } from 'react-redux'

import {ModalBase} from '../ModalBase'

import Printer from '../../../media/felsv/Printer.svg'
import Email from '../../../media/felsv/Email.svg'
import Download from '../../../media/felsv/Download.svg'
import Folder from '../../../media/felsv/Folder.svg'
import DownloadImage from '../../../media/felsv/DownloadImage.svg'
import DownloadJson from '../../../media/felsv/DownloadJson.svg'
import DeleteFileIcon from '../../../media/felsv/dark_delete_file_icon.svg'
import FileReloadIcon from '../../../media/felsv/Dark_File_Reload.svg'
import DocumentCheckIcon from '../../../media/felsv/DarkDocumentCheck.svg'

import { setModoTicketPrint, setStatusModalAnular, setStatusModalEnvio, setStatusModalImprimir } from '../../../actions/historial/historial.actions'
import { actionsOperaciones } from '../../../actions/action-creators'
import { bindActionCreators } from 'redux'
import { State } from '../../../reducers'
import { generalOpenModalInfo, generalShowLoader, msgFuncionalidadLimitada, validateHorarioSucursal } from '../../../actions/general.actions'

interface DocumentoActivo {
  Documento?: string
  Sello?: string
  SelloBusqueda?: string
}

interface PropsAcciones {
  onCancel: () => void
  factura: any
  qrCode: string
  anulado: boolean
  version: 'certificado' | 'contingencia'
  onCambiarVersion: (version: 'certificado' | 'contingencia') => void
  docActivo: DocumentoActivo
  docContingencia: any
}

const ModalHistorialAcciones = (props: PropsAcciones) => {
  const {qrCode, factura, anulado, version, onCambiarVersion, docActivo, docContingencia} = props;
  const {datos, config} = useSelector((state: State) => state.userLogin);
  
  const dispatch = useDispatch();
  const {getExcelFactura, getFacturaPDF_New, getFacturaImage, descargarJson} = bindActionCreators(actionsOperaciones, dispatch);


  const numeroControl = factura?.DetallesDTE?.identificacion?.numeroControl;

  const documentoListo = () => {
    if (docActivo.Documento && docActivo.Sello) return true;

    dispatch(generalOpenModalInfo('No se pudo obtener esta versión del documento. Intente nuevamente.'));
    return false;
  }

  const handleExcel = () => {
    if (!documentoListo()) return;

    getExcelFactura(
      {Documento: docActivo.Documento!, Sello: docActivo.Sello!},
      numeroControl
    );
  }

  const handlePDF = (modoTicket: boolean = false) => {
    if (!documentoListo()) return;

    getFacturaPDF_New(
      {
        Documento: docActivo.Documento,
        Sello: docActivo.Sello,
        SelloBusqueda: docActivo.SelloBusqueda,
        ModoTicket: modoTicket,
      },
      numeroControl,
      factura?.estadoanulacion
    );
  }

  const handleImage = () => {
    if (!documentoListo()) return;

    getFacturaImage(
      {Documento: docActivo.Documento, Sello: docActivo.Sello, SelloBusqueda: docActivo.SelloBusqueda},
      numeroControl
    );
  }

  const jsonDeContingencia = () => {
    try {
      const carga = docContingencia?.documento?.split('.')[1];
      if (!carga) return null;

      const relleno = '='.repeat((4 - (carga.length % 4)) % 4);
      const dte = JSON.parse(
        decodeURIComponent(escape(window.atob((carga + relleno).replace(/-/g, '+').replace(/_/g, '/'))))
      );

      const contenido = {
        ...dte,
        selloRecibido: docContingencia.selloRecibido,
        firmaElectronica: docContingencia.documento,
      };

      return window.btoa(unescape(encodeURIComponent(JSON.stringify(contenido))));
    } catch (error) {
      return null;
    }
  }

  const handleJson = () => {
    const json = version === 'contingencia' ? jsonDeContingencia() : factura?.JsonFacturaFile;

    if (!json) {
      dispatch(generalOpenModalInfo('No se pudo generar el archivo json de esta versión del documento.'));
      return;
    }

    descargarJson({
      idFactura: factura?.DetallesDTE?.identificacion?.codigoGeneracion,
      json,
      nombre: version === 'contingencia' ? 'Contingencia' : undefined,
    });
  }

  const handleAnular = async () => {
    //if (datos?.aspel) {
    //  dispatch(generalOpenModalInfo(msgFuncionalidadLimitada(datos)));
    //  return;
    //}
    if (factura?.esContingencia === true && factura?.tieneCertificado !== true) {
      dispatch(generalOpenModalInfo('El documento se emitió en contingencia y aún no lo ha certificado Hacienda. La anulación también viaja a Hacienda, así que hay que esperar a que el documento quede certificado.'));
      return;
    }

    if(await dispatch(validateHorarioSucursal('', '/', true, 'anular el documento'))) {
      dispatch(setStatusModalAnular(true))
    }
  }

  return (
    <ModalBase>
      <div className='modal-card' style={{width: '100%'}}>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>Más opciones</h3>
          </div>
          <div className='form-separator'></div>
          {factura?.esContingencia === true && (
            <>
              <div className='modal-version-tabs' role='tablist'>
                <button
                  type='button'
                  role='tab'
                  aria-selected={version === 'certificado'}
                  className={`modal-version-tab es-certificado ${version === 'certificado' ? 'activa' : ''}`}
                  disabled={factura?.tieneCertificado !== true}
                  title={
                    factura?.tieneCertificado !== true
                      ? 'Hacienda todavía no ha certificado este documento'
                      : undefined
                  }
                  onClick={() => onCambiarVersion('certificado')}
                >
                  <img src={DocumentCheckIcon} alt='' />
                  <span>Certificado por Hacienda</span>
                </button>
                <button
                  type='button'
                  role='tab'
                  aria-selected={version === 'contingencia'}
                  className={`modal-version-tab es-contingencia ${version === 'contingencia' ? 'activa' : ''}`}
                  onClick={() => onCambiarVersion('contingencia')}
                >
                  <img src={FileReloadIcon} alt='' />
                  <span>Contingencia</span>
                </button>
              </div>
              <p className='modal-version-nota'>
                {version === 'contingencia'
                  ? 'Las acciones de abajo se aplican al comprobante que se le entregó al cliente, sin sello de recepción.'
                  : 'Las acciones de abajo se aplican al documento con el sello que Hacienda otorgó.'}
              </p>
            </>
          )}
          <div className='modal-emitido-div-qr'>
            {
              qrCode && (
                <img
                  src={qrCode}
                  alt='qr'
                  className='modal-emitido-img-qr'
                />
              )
            }
          </div>
          <div
            className='m button-actions'
            style={{margin: '0 auto', width: '100%', textAlign: 'center'}}
          >
            <div className='flex-full-center flex-wrap' style={{alignItems: 'start'}}>
              <div>
                <button className='modal-emitido-button-icon'>
                  <img src={Printer} alt='Imprimir' onClick={() => dispatch(setStatusModalImprimir(true))} />
                </button>
                <label className='modal-accion-descripcion'>Imprimir</label>
              </div>
              <div>
                <button className='modal-emitido-button-icon'>
                  <img src={Email} alt='correo electrónico' onClick={() => dispatch(setStatusModalEnvio(true))} />
                </button>
                <label className='modal-accion-descripcion'>Enviar</label>
              </div>
              <div className='vertical-separator-btns'></div>
              <div>
                <button className='modal-emitido-button-icon' onClick={() => handlePDF()}>
                  <img src={Download} alt='Download' />
                </button>
                <label className='modal-accion-descripcion'>Descargar PDF</label>
              </div>
              <div>
                <button className='modal-emitido-button-icon'>
                  <img src={Folder} alt='Download folder' onClick={handleExcel}/>
                </button>
                <label className='modal-accion-descripcion'>Descargar CSV</label>
              </div>
              <div>
                <button className='modal-emitido-button-icon'>
                  <img src={DownloadImage} alt='Download 2' onClick={handleImage} />
                </button>
                <label className='modal-accion-descripcion'>Descargar imagen</label>
              </div>       
              <div>
                <button className='modal-emitido-button-icon'>
                  <img src={DownloadJson} alt='Download JSON' onClick={handleJson} />
                </button>
                <label className='modal-accion-descripcion'>Descargar json</label>
              </div> 
              {/* <div>
                <button className='modal-emitido-button-icon'>
                  <img src={ReloadFileIcon} alt='Anular factura' />
                </button>
                <label className='modal-accion-descripcion'>Nota de Crédito</label>
              </div> */}
              {
                (
                  !anulado
                ) &&
                (
                  <>
                  <div className='vertical-separator-btns'></div>
                  <div>
                    <button className='modal-emitido-button-icon'>
                      <img src={DeleteFileIcon} alt='Anular factura' onClick={handleAnular} />
                    </button>
                    <label className='modal-accion-descripcion'>Anular</label>
                  </div>
                  </>
                )
              }
            </div>
          </div>
          {config?.tickethabilitado && (
            <>
              <div className='form-separator'></div>
              <label style={{ textAlign: 'center', display: 'block' }}>Opciones Ticket:</label>
              <div className='m button-actions' style={{margin: '0 auto', width: '100%', textAlign: 'center'}}>
                <div className='flex-full-center flex-wrap' style={{alignItems: 'start'}}>
                  <div>
                    <button className='modal-emitido-button-icon'>
                      <img src={Printer} alt='Imprimir ticket' onClick={() => { dispatch(setModoTicketPrint(true)); dispatch(setStatusModalImprimir(true)); }} />
                    </button>
                    <label className='modal-accion-descripcion'>Imprimir ticket</label>
                  </div>
                  <div>
                    <button className='modal-emitido-button-icon' onClick={() => handlePDF(true)}>
                      <img src={Download} alt='Descargar ticket' />
                    </button>
                    <label className='modal-accion-descripcion'>Descargar PDF Ticket</label>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button className='m button transparent w-inline-block' onClick={props.onCancel}>
              <div>Cerrar</div>
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalHistorialAcciones
